
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { fromDTO as mapper } from './mappers/incidentServiceMapper';
import { fromDTO as updateMapper } from './mappers/updateIncidentsMapper';
import { fromDTO as createMapper } from './mappers/createIncidentsMapper';
import { publishAndAwait } from '../../../app/coreSlice';

const updateIncident = async data => {

	if (typeof data === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const subType = !!data.incidentCode ? 'INCIDENT_UPDATE' : 'INCIDENT_CREATE';

	const message = !!data.incidentCode ? updateMapper(data) : createMapper(data);

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'RESERVATION',
			subType,
			message,
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}
  
	return mapper(processMessage);
};

export default updateIncident;